import type { FormatCheckerVariant } from '../types';

export const FORMAT_CHECKER_TIDBITS = [
  'Tip: ATS systems reject 75% of resumes before human review.',
  'Did you know? Consistent heading styles improve parse accuracy by 60%.',
  'Most CV parsers struggle with tables, columns, and graphics.',
  'Single-column formats score highest in automated document structure checks.',
  'Recruiters spend on average 6 seconds scanning a resume — formatting matters.',
  'Clear section headings make your resume 40% more likely to pass automated filters.',
  'A two-page resume is ideal for professionals with 5+ years of experience.',
];

export const PAGE_TIDBITS: Partial<Record<FormatCheckerVariant, string>> = {
  uae: 'UAE MoHRE requires explicit nationality and visa status fields in CVs.',
  europass:
    'Europass CVs must follow the EU standard section order to pass automated screening.',
  germany:
    'German Lebenslauf expects Bewerbungsfoto, Persönliche Daten, and CEFR language grades.',
};

export function getTidbits(variant: FormatCheckerVariant): string[] {
  const tidbits = FORMAT_CHECKER_TIDBITS.slice();
  const pageSpecific = PAGE_TIDBITS[variant];
  if (pageSpecific) {
    tidbits.push(pageSpecific);
  }
  return tidbits;
}
